import { CH_HOME_FEATURE } from '@propertypal/shared/src/constants/content-hub';
import getArticleCategory from '@propertypal/shared/src/utils/getArticleCategory';
import React from 'react';
import { Container, Wrapper } from './ContentHubArticleGrid.style';
import ContentHubArticleGridResults, { ContentHubArticleGridResultsProps } from './ContentHubArticleGridResults';
import ContentHubBreadcrumbs from './ContentHubBreadcrumbs';

interface Props extends ContentHubArticleGridResultsProps {
  categorySlug: string;
  subCategorySlug: string;
  homeLink: string;
}

const ContentHubArticleGrid = (props: Props) => {
  const subCategoryName =
    (props.articles.length && props.articles[0].attributes.subCategories?.data[0].attributes.subCategory) || '';

  return (
    <Container>
      <Wrapper>
        <ContentHubBreadcrumbs
          breadcrumbs={[
            CH_HOME_FEATURE ? { title: 'Home', url: props.homeLink } : undefined,
            { title: getArticleCategory(props.categorySlug), url: `/${props.categorySlug}` },
            { title: subCategoryName, url: `/${props.categorySlug}/${props.subCategorySlug}` },
          ]}
          mb={30}
        />

        <h2>{subCategoryName}</h2>

        <ContentHubArticleGridResults
          articles={props.articles}
          page={props.page}
          totalPages={props.totalPages}
          url={props.url}
        />
      </Wrapper>
    </Container>
  );
};

export default ContentHubArticleGrid;
